module.exports = __webpack_public_path__ + "static/img/h4.01365c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h4.png
// module id = CnRi
// module chunks = 1